import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface SecondaryStructureTabProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  models: Array<any>;
  name: string;
  primer: string;
  primer2: string;
  temperature: number;
}

function SecondaryStructureTab({
  models,
  name,
  primer,
  primer2,
  temperature,
}: SecondaryStructureTabProps): JSX.Element {
  return (
    <div className="buffer-content-container">
      <div className="row">
        <div className="col col-md-12">
          Showing all <b>{name}</b> secondary structures for{' '}
          {name === 'heterodimer' ? (
            <>
              primers <b>{primer}</b> and <b>{primer2}</b>
            </>
          ) : (
            <>
              primer <b>{primer}</b>
            </>
          )}{' '}
          at {temperature}&deg;C.
        </div>
      </div>
      <div className="row">
        <div className="col col-md-12">
          <table className="table table-hover">
            <colgroup>
              <col className="dg" />
              <col className="structure" />
            </colgroup>
            <thead>
              <tr>
                <th className="deltag">&Delta;G (kcal)</th>
                <th>Structure</th>
              </tr>
            </thead>
            <tbody>
              {models.map((model) => (
                <tr key={model.get('index')} data-index={model.get('index')}>
                  <td className="deltag">{model.get('dg')}</td>
                  <td
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{__html: model.get('smallSvg')}}
                  />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<SecondaryStructureTabProps>(SecondaryStructureTab);
